import React, { useEffect, useMemo, useState } from 'react';
import { Bubble, Dropdown, List } from 'tea-component';

import SvgIcon from '@/pages/home/components/SvgIcon';
import { useDblIntl } from '@/pages/datalab/utils/utils';
import { useChartTypeList } from './_hooks';

import './index.scss';

const ChartDropdown = (props: any) => {
  const { curChartType, onChange, isNoDate = false } = props;
  const { formatMessage, isEn } = useDblIntl();
  const chartList = useChartTypeList();

  const [actionType, setActionType] = useState('StackBarChart');
  const [actionIcon, setactionIcon] = useState<any>('column-chart');
  const [actionTitle, setActionTitle] = useState<any>('');

  // 需要日期维度的图表类型
  const lineChartList = ['LineChart', 'StackBarChart'];

  useEffect(() => {
    const chart = chartList.find((e, i) => e.list.find((item, index) => item?.type == actionType));
    setactionIcon(chart?.icon);
    setActionTitle(chart?.title);
  }, [actionType, isEn]);

  useEffect(() => {
    // 外部传入筛选图表类型
    if (curChartType) setActionType(curChartType);
  }, [curChartType]);

  return (
    <Dropdown
      trigger="click"
      clickClose={false}
      className='dbl-chart-dropdownbox'
      button={
        <div className="dbl-chart-dropdowntext">
          <SvgIcon
            type={actionIcon}
            className="dbl-chart-dropdowntext-icon"
          />
          {actionTitle}
        </div>
      }
      placement="bottom-end"
    >
      {(close) => (
        <div className="dbl-chart-dropdown">
          {chartList?.map((e: any, i: any) => (
            <div key={i} className="dbl-chart-dropdown-itembox">
              <div className="dbl-chart-dropdown-text">{e?.title}</div>
              <div className="dbl-chart-dropdown-flex">
                {e?.list?.map((item: any, index: any) => (
                  <Bubble
                    placement="top"
                    dark
                    content={isNoDate && lineChartList?.includes(item?.type) ? formatMessage({ id: 'dbl_multi_chart_select_message' }, { text: isEn ? item?.text?.toLowerCase() : item?.text }) : null}
                  >
                    <div
                      className={`dbl-chart-dropdown-item ${item?.type == actionType ? 'action' : ''} ${isNoDate && lineChartList?.includes(item?.type) ? 'disabled' : ''}`}
                      onClick={(e) => {
                        if (isNoDate && lineChartList?.includes(item?.type)) {
                          return;
                        }
                        setActionType(item?.type);
                        onChange && onChange(item, e);
                        close();
                      }}
                    >
                      <img
                        className="dbl-chart-dropdown-img"
                        src={item.img}
                        key={index}
                      />
                    </div>
                  </Bubble>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </Dropdown>
  );
};

export default ChartDropdown;
